/**
 * Safe Meta Pixel wrapper. Every call reports whether it was enqueued, because the purchase
 * coordinator only marks an order as reported when at least one destination took the event.
 */
const fqb = (...args: Parameters<FBQ>): boolean => {
  if (!window?.fbq) return false;

  window.fbq(...args);
  return true;
};

/**
 * @description Used for track when user adds a product to cart
 */
function addToCart(): boolean {
  return fqb('track', 'AddToCart');
}

/**
 * @description Used for track when the user wants to finish a purchase
 */
function initiateCheckout(): boolean {
  return fqb('track', 'InitiateCheckout');
}

/**
 * @description Used when the user adds a payment method
 */
function addPaymentInfo(): boolean {
  return fqb('track', 'AddPaymentInfo');
}

/**
 * @description Used for track when purchase is completed
 */
function purchase(value: number): boolean {
  return fqb('track', 'Purchase', { value, currency: 'BRL' });
}

/**
 * @description Used for track a page view, either on boot or on SPA navigation
 */
function pageView(): boolean {
  return fqb('track', 'PageView');
}

const FbPixel = {
  event: {
    pageView,
    addToCart,
    initiateCheckout,
    addPaymentInfo,
    purchase,
  },
};

export default FbPixel;
